import { useStatsigClient } from '@statsig/react-bindings';

export const useStatsigIsReady = () => {
  const { client } = useStatsigClient();
  return client.loadingStatus === 'Ready';
};
